import { TICKER_SYMBOLS } from "../lib/constants";
import { TrendingUp, TrendingDown } from "lucide-react";

// Each quote is its own little capsule so the strip reads as a row of soft
// tokens rather than a dense data tape.
function TickerRow() {
    return (
        <>
            {TICKER_SYMBOLS.map((t, i) => (
                <span
                    key={i}
                    data-testid={`ticker-item-${t.symbol.replace(/[^a-zA-Z0-9]/g, "")}`}
                    className="group inline-flex items-center gap-2 mx-1.5 my-1.5 pl-3.5 pr-2 py-1.5 rounded-full bg-surface font-mono text-[11px]"
                >
                    <span className="text-dim tracking-wide">{t.symbol}</span>
                    <span className="text-foreground font-medium tabular-nums">{t.value}</span>
                    <span
                        className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium tabular-nums ${
                            t.up ? "bg-pos/15 text-pos-ink" : "bg-neg/15 text-neg-ink"
                        }`}
                    >
                        {t.up ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
                        {t.change}
                    </span>
                </span>
            ))}
        </>
    );
}

export function StockTicker() {
    return (
        <div
            className="relative h-12 flex items-center overflow-hidden bg-surface-raised"
            data-testid="stock-ticker"
        >
            <span className="hidden sm:inline-flex items-center gap-2 ml-4 mr-2 shrink-0 rounded-full bg-accent px-4 py-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-foreground animate-pulse-dot" />
                <span className="font-display text-[10px] font-semibold uppercase tracking-[0.16em] text-accent-foreground">
                    Markets
                </span>
            </span>
            <div className="relative flex-1 overflow-hidden">
                <div className="ticker-track">
                    <TickerRow />
                    <TickerRow />
                </div>
                {/* Edge fades so items dissolve rather than clip */}
                <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-surface-raised to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-surface-raised to-transparent" />
            </div>
        </div>
    );
}
